import { tileHex, tileIcon } from '../lib/tile-art';

/** A tile's chip: white icon on a full-strength brand colour. */
export function TileIcon({ icon, colour, small = false }: { icon: string; colour: string; small?: boolean }) {
  const Icon = tileIcon(icon);
  return (
    <span
      className={`flex shrink-0 items-center justify-center rounded-lg text-white ${small ? 'h-7 w-7' : 'mt-0.5 h-10 w-10'}`}
      style={{ backgroundColor: tileHex(colour) }}
    >
      <Icon className={small ? 'h-4 w-4' : 'h-5 w-5'} />
    </span>
  );
}
